document.addEventListener('DOMContentLoaded', () => {
    // Addition items
    $('.new-pdp-product-collection__list--mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        dotsClass: 'new-pdp-product-collection__dots',
        adaptiveHeight: true,
        centerMode: true,
        fade: true
    });
});